import type { FlowNodeData } from '$/domains/workFlowV3/type';

/**
 * 给快速开始生成的节点数据补上持久关闭标记，并保留已有字段。
 */
export function markQuickStartDismissed<TData extends Record<string, unknown>>(data: TData) {
  return {
    ...data,
    quickStartDismissed: true as const,
  };
}

/**
 * 判断当前节点是否已经点击过快速开始。
 */
export function isQuickStartDismissed(
  data: Pick<FlowNodeData, 'quickStartDismissed'> | null | undefined,
) {
  return data?.quickStartDismissed === true;
}

/**
 * 快速开始预填完成后沿用“已有输入节点”的展示状态。
 */
export function hasNodeInputState(
  hasLinkedInputNode: boolean,
  data: Pick<FlowNodeData, 'quickStartDismissed'> | null | undefined,
) {
  return hasLinkedInputNode || isQuickStartDismissed(data);
}
